@let assistantDisplays = assistantDisplaysSg();
@let overlayIsOpen = overlayIsOpenSg();
@let selectedAssistantDisplay = selectedAssistantDisplaySg();
@let disabled = disabledSg();

<div
  class="atn-assistant-switcher"
  [class.atn-assistant-switcher--disabled]="disabled"
  #origin
  (click)="!disabled && overlayIsOpenSg.set(!overlayIsOpen)"
>
  <i
    class="atn-assistant-switcher__icon atn-icon atn-{{
      selectedAssistantDisplay?.icon
    }} atn-blue"
  ></i>
</div>

@if (overlayIsOpen) {
  <atn-ds-attached-overlay
    (backdropClick)="overlayIsOpenSg.set(false)"
    [origin]="origin"
    [offsetX]="35"
    [offsetY]="-5"
  >
    <div class="atn-assistant-switcher__overlay">
      @for (assistantDisplay of assistantDisplays; track assistantDisplay.id) {
        <div
          class="atn-assistant-switcher__overlay-item"
          [title]="assistantDisplay.description"
          [class.atn-assistant-switcher__overlay-item--active]="
            assistantDisplay.id === selectedAssistantDisplay?.id
          "
          (click)="
            selectedAgentId.set(assistantDisplay.id); overlayIsOpenSg.set(false)
          "
        >
          <i
            class="atn-assistant-switcher__overlay-item-icon atn-icon atn-{{
              assistantDisplay.icon
            }} atn-blue"
          ></i>

          {{ assistantDisplay.name }}
        </div>
      }
    </div>
  </atn-ds-attached-overlay>
}
